export default __webpack_public_path__ + "static/mc-datatag-gif-608d427d52d89b30667b58767051cb32.mp4";